import React, { PureComponent } from 'react';
import { Button } from '@ui-propulsion/react-components';
import classNames from 'classnames';
import BackButton from './back-button';
import Spinner from './spinner';

class Ownership extends PureComponent {
  state = {
    selection: this.props.practice.boSignificantOwnerFlag
      ? this.props.practice.boSignificantOwnerFlag.toLowerCase()
      : null
  }

  handleChange = (e) => {
    const { value: selection } = e.target;
    this.setState({ selection });
  }

  handleClick = () => {
    const { selection } = this.state;
    const { history, actions, location } = this.props;
    if (selection) {
      const data = { boSignificantOwnerFlag: selection };
      actions.submitOwnershipFlag(data)
      .then(() => {
        actions.setPreviousRoute('/patientsolutions/enroll/ownership');
        const path = selection.toLowerCase() === 'yes'
          ? 'add-owners'
          : 'significant-owner';
        history.push(`/patientsolutions/enroll/ownership/${path}${location.search ? location.search : ''}`);
      })
      .catch(({ response }) => {
        const { status, data } = response;

        if (status && status !== 400) {
          window.location.href = '/patientsolutions/enroll/error';
        }

        if (data && data.redirectTo) {
          window.location.href = data.redirectTo;
        }
      });
    }
  }

  render() {
    const { selection } = this.state;
    const { isInReview, onboarding } = this.props;
    const { processingSubmit, hasCompletedReview } = onboarding;
    const previousRoute = isInReview
      ? '/patientsolutions/enroll/review'
      : '/patientsolutions/enroll/payment-plans';

    return <section className='ownership-section'>
      <BackButton {...this.props} previousRoute={previousRoute} />
      <h1 className='section-title'>Does your practice have any owners who individually own 25% or more of the practice?</h1>
      <div className='choices'>
        <div className='choice-container'>
          <label className={classNames('choice', { 'choice--selected': selection === 'yes' })}>
            <input data-test-id="ownership-yes-radio-button" id='ownershipSelectionYes' checked={selection === 'yes'} type="radio" value="yes" name="ownershipSelection" onChange={this.handleChange}></input>
            <span className='choice-option'>Yes</span>
            <span className='choice-option-desc'>My practice has at least one owner who owns 25% or more of the business.</span>
          </label>
        </div>
        <div className='choice-container'>
          <label className={classNames('choice', { 'choice--selected': selection === 'no' })}>
            <input data-test-id="ownership-no-radio-button" id='ownershipSelectionNo' checked={selection === 'no'} type="radio" value="no" name="ownershipSelection" onChange={this.handleChange}></input>
            <span className='choice-option'>No</span>
            <span className='choice-option-desc'>None of my practice’s owners own 25% or more of the business.</span>
          </label>
        </div>
      </div>
      <p className='legal-disclosure'>
        As a legal entity registering to be our client, federal regulations require us to obtain and verify personal information about everyone who directly or indirectly owns 25% or more of the practice. You will also need to identify the owner or individual who has significant responsibility to manage the business. We value your information and anything you share will be strictly used for verification purposes only.
      </p>
      <div className='action-area'>
        <Button
          data-test-id="next-step-button"
          onClick={this.handleClick}
          className={classNames('button-submit button-submit-next', { disabled: selection === null || hasCompletedReview })}
          disabled={selection === null || hasCompletedReview}
          aria-label='practice submit button'>
          <span className='button-submit-text'>Next</span> <span className='chevron-white-right' />
        </Button>
      </div>

      { processingSubmit && <Spinner processingSubmit={processingSubmit}/> }

    </section>;
  }
}

export default Ownership;

